var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue } from 'vue-property-decorator';
import GlobalEventBus from "../services/GlobalEventBus";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import TokenService from "../services/token.service";
import axiosInstance from "../services/api";
// DISPO-1216: Access-Token vor dem STOMP-CONNECT erneuern, wenn er in weniger als
// dieser Zeit ablaeuft (Uhrenabweichung Browser/Server abfedern).
var TOKEN_REFRESH_MARGIN_MS = 60 * 1000;
// DISPO-1216: kurze Trennungen (Ruhezustand, WLAN-Wechsel, Tool-Neustart) still neu verbinden;
// der Fehler-Toast kommt erst, wenn die Verbindung nach dieser Frist immer noch nicht steht.
var SOCKET_ERROR_TOAST_GRACE_MS = 30 * 1000;
/**
 * DISPO-1216: Ablaufzeitpunkt (ms) aus dem exp-Claim des JWT lesen, ohne Signaturpruefung.
 * null, wenn der Token nicht lesbar ist.
 */
function getJwtExpiryMs(token) {
    try {
        var payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        var claims = JSON.parse(window.atob(payload));
        return typeof claims.exp === "number" ? claims.exp * 1000 : null;
    }
    catch (e) {
        return null;
    }
}
export default Vue.extend({
    mixins: [],
    data: function () {
        return {
            heartBeatIntervalId: 0,
            reconnectTimeoutId: null, // DISPO-1197: anstehender Reconnect, wird bei disconnect() verworfen
            tabId: "", //unique tabId for the heartbeat message
            connected: false,
            socket: null,
            connecting: false, // DISPO-1216: Token-Refresh + CONNECT laufen, kein zweiter connect()
            forceTokenRefresh: false, // DISPO-1216: Server hat den Token abgelehnt -> vor dem naechsten Versuch erneuern
            socketErrorToastShown: false, // DISPO-1216: Fehler-Toast nur einmal je Stoerung, nicht bei jedem Reconnect
            socketErrorToastTimeoutId: null, // DISPO-1216: verzoegerter Fehler-Toast, faellt weg wenn der Reconnect klappt
            pendingSocketErrorText: "", // DISPO-1216: Text des letzten Fehlschlags fuer den verzoegerten Toast
            pendingSocketErrorHideDelay: 5000,
        };
    },
    methods: {
        sendEditModeUpdate: function (editModeActive) {
            this.$configuration.socketHeartBeatStatus.editModeActive = editModeActive;
            this.sendHeartBeatMessage("editModeUpdate");
        },
        /**
         * send a message to the socket server to indicate that the user started editing a property field (focus has been set on the field)
         * @param {*} entityType the type of entity that of which the property field has been focused, e.g. "Meeting", "Customer", "Event" etc.
         * @param {*} entityId the entity id (primary key) that is currently open in the editing view and where the property that has been focused on belongs to
         * @param {*} propertyName the name of the entity property that has gotten the focus
         */
        sendStartEditSocketMessage: function (entityType, entityId, propertyName) {
            this.$configuration.socketHeartBeatStatus.focussedFieldId = propertyName;
            this.$configuration.socketHeartBeatStatus.entityId = entityId;
            this.sendHeartBeatMessage("StartEdit");
            if (this.$configuration.stompClient &&
                this.$configuration.stompClient.connected) {
                var status = {
                    statusType: "StartEdit",
                    entityType: entityType,
                    entityId: entityId,
                    propertyName: propertyName,
                    username: this.currentUser.username,
                };
                try {
                    this.$configuration.stompClient.send("/app/editstatus", JSON.stringify(status), {});
                }
                catch (error) {
                    // eslint-disable-next-line
                    console.error(error);
                }
            }
        },
        /**
         * send a message to the socket server to indicate that the user finished editing a property field (blur event has been called on a field)
         * @param {*} entityType the type of entity that of which the property field has been de-focused (blur event), e.g. "Meeting", "Customer", "Event" etc.
         * @param {*} entityId the entity id (primary key) that is currently open in the editing view and where the property that has been edited belongs to
         * @param {*} propertyName the name of the entity property that has been edited
         */
        sendStopEditSocketMessage: function (entityType, entityId, propertyName) {
            this.$configuration.socketHeartBeatStatus.focussedFieldId = null;
            this.$configuration.socketHeartBeatStatus.entityId = null;
            this.sendHeartBeatMessage("StopEdit");
            if (this.$configuration.stompClient &&
                this.$configuration.stompClient.connected) {
                var status = {
                    statusType: "StopEdit",
                    entityType: entityType,
                    entityId: entityId,
                    propertyName: propertyName,
                    username: this.currentUser.username,
                };
                try {
                    this.$configuration.stompClient.send("/app/editstatus", JSON.stringify(status), {});
                }
                catch (error) {
                    // eslint-disable-next-line
                    console.error(error);
                }
            }
        },
        /**
         * handle edit status update messages via socket connection.
         * These events occur when a user puts focus on an input field (to start editing) or focus is blurred (user leaves the field)
         */
        handleEditStatusUpdate: function (message) {
            if (message.body.startsWith("{")) {
                var eventMessageBody = JSON.parse(message.body);
                //check if current user did not cause this update itself, otherwise we just ignore it
                if (eventMessageBody.username != this.currentUser.username) {
                    // eslint-disable-next-line no-console
                    console.debug("got edit status update message from user " +
                        eventMessageBody.username, eventMessageBody);
                    if (eventMessageBody.statusType == "StartEdit") {
                        GlobalEventBus.$emit("StartEdit", eventMessageBody);
                    }
                    else if (eventMessageBody.statusType == "StopEdit") {
                        GlobalEventBus.$emit("StopEdit", eventMessageBody);
                    }
                    else {
                        // eslint-disable-next-line no-console
                        console.log("Unknown edit status update message received, statsType is not supported: ", eventMessageBody);
                    }
                }
            }
        },
        /**
         * handle socket message that contains infos about all users currently logged on to the system
         */
        handleUsersStatusUpdate: function (message) {
            if (message.body.startsWith("{")) {
                var eventMessageBody = JSON.parse(message.body);
                // eslint-disable-next-line no-console
                //console.debug("got user status update message", eventMessageBody);
                GlobalEventBus.$emit("UserStatusUpdate", eventMessageBody);
            }
        },
        /**
         * handle events from the /topic/updates topic that are received via websocket connection.
         * These events can be:
         *   - User Logs in
         *   - User created, deleted or updated an entity
         */
        handleUpdatesTopicMessage: function (message) {
            if (message.body.startsWith("{")) {
                var eventMessageBody = JSON.parse(message.body);
                // eslint-disable-next-line
                // console.log("got message of type: " + eventMessageBody.messageType);
                if (eventMessageBody.messageType == "ContentUpdateEvent") {
                    //check if event has been generated by another user, otherwise ignore
                    if (this.currentUser &&
                        this.currentUser.username != eventMessageBody.initiatingUserName) {
                        //handle updates depending on the view we are on
                        GlobalEventBus.$emit("ContentUpdateEvent", eventMessageBody);
                        this.$bvToast.toast(eventMessageBody.message, {
                            autoHideDelay: 3000,
                            noCloseButton: true,
                            variant: "success",
                            solid: false,
                        });
                    }
                }
                else if (eventMessageBody.messageType == "UserConnectionEvent") {
                    if (this.currentUser &&
                        this.currentUser.username != eventMessageBody.userName) {
                        switch (eventMessageBody.eventType) {
                            case "TYPE_LOGIN":
                                this.$bvToast.toast(eventMessageBody.userName + " hat sich am System angemeldet", {
                                    autoHideDelay: 2500,
                                    noCloseButton: false,
                                    variant: "success",
                                    solid: false,
                                });
                                break;
                            case "TYPE_WSCONNECT":
                                this.$bvToast.toast(eventMessageBody.userName + " hat sich verbunden", {
                                    autoHideDelay: 1500,
                                    noCloseButton: false,
                                    variant: "success",
                                    solid: false,
                                });
                                break;
                            default:
                                // eslint-disable-next-line
                                console.log("Got unhandled user Event: ", eventMessageBody);
                                break;
                        }
                    }
                }
                else {
                    this.$bvToast.toast(JSON.stringify(eventMessageBody), {
                        autoHideDelay: 2000,
                        noCloseButton: true,
                        variant: "danger",
                        solid: false,
                    });
                }
            }
            else {
                // eslint-disable-next-line
                // console.log("received non object event");
                this.$bvToast.toast(message.body, {
                    autoHideDelay: 1000,
                    noCloseButton: true,
                    variant: "success",
                    solid: false,
                });
            }
        },
        /**
         * send the first hello message to the server to indicate we are here and started listening
         */
        sendConnectionHello: function () {
            if (this.$configuration.stompClient &&
                this.$configuration.stompClient.connected) {
                var msg = { name: this.currentUser.username };
                this.$configuration.stompClient.send("/app/hello", JSON.stringify(msg), {});
            }
        },
        /**
         * assemble and send an actual heartbeat message to the server (to the /app/heartbeat topic)
         */
        sendHeartBeatMessage: function (msg) {
            console.log("Heartbeat function called for " + msg);
            if (this.$configuration.stompClient &&
                this.$configuration.stompClient.connected) {
                //set current URL and then send heartbeat info
                this.$configuration.socketHeartBeatStatus.activePageUrl = this.$route.fullPath;
                var heartBeatMessage = {
                    userTabStatus: this.$configuration.socketHeartBeatStatus,
                };
                try {
                    this.$configuration.stompClient.send("/app/heartbeat", JSON.stringify(heartBeatMessage), {});
                }
                catch (error) {
                    // eslint-disable-next-line
                    console.error(error);
                }
            }
        },
        /**
         * Start an interval to send heartbeat messages to the server every 5 seconds
         */
        startHeartBeat: function () {
            //start sending heartbeat message every 5 seconds
            if (this.heartBeatIntervalId) {
                //clear previous interval first if any
                this.stopHeartBeat();
            }
            this.heartBeatIntervalId = setInterval(this.sendHeartBeatMessage, 5000);
        },
        /**
         * clear the heartbeat interval to stop sending heartbeat messages to the server
         */
        stopHeartBeat: function () {
            if (this.heartBeatIntervalId) {
                clearInterval(this.heartBeatIntervalId);
                this.heartBeatIntervalId = null;
            }
        },
        /**
         * DISPO-1216: gueltigen Access-Token fuer den STOMP-CONNECT liefern.
         * Der Socket laeuft nicht durch den Axios-Interceptor, der abgelaufene Tokens bei
         * einer 401 still erneuert. Ohne diesen Schritt schickte ein Reconnect nach
         * Ablauf des Tokens (Tab lange offen, Backend-Restart, Netz weg) immer wieder
         * denselben abgelaufenen Token -> Abweisung + Fehler-Toast alle 5 s.
         * Erneuert, wenn der Token (fast) abgelaufen ist oder der Server ihn abgelehnt hat.
         * Liefert null, wenn kein Token beschafft werden konnte.
         */
        ensureFreshSocketToken: function () {
            return __awaiter(this, void 0, Promise, function () {
                var token, expiryMs, needsRefresh, refreshToken, rs, accessToken, error_1, status;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            token = TokenService.getLocalAccessToken();
                            expiryMs = token ? getJwtExpiryMs(token) : null;
                            needsRefresh = !token ||
                                this.forceTokenRefresh ||
                                (expiryMs !== null && expiryMs - Date.now() < TOKEN_REFRESH_MARGIN_MS);
                            if (!needsRefresh) {
                                return [2 /*return*/, token];
                            }
                            refreshToken = TokenService.getLocalRefreshToken();
                            if (!refreshToken) {
                                return [2 /*return*/, null];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, axiosInstance.post("/auth/refreshtoken", { refreshToken: refreshToken })];
                        case 2:
                            rs = _a.sent();
                            accessToken = rs.data.accessToken;
                            this.$store.dispatch("auth/refreshToken", accessToken);
                            TokenService.updateLocalAccessToken(accessToken);
                            this.forceTokenRefresh = false;
                            return [2 /*return*/, accessToken];
                        case 3:
                            error_1 = _a.sent();
                            status = error_1 && error_1.response ? error_1.response.status : null;
                            if (status === 403) {
                                // Refresh-Token abgelaufen: wie der Axios-Interceptor abmelden statt endlos zu reconnecten
                                GlobalEventBus.$emit("userLogoutPerformed");
                                this.$store.dispatch("auth/logout");
                                this.$store.commit("auth/sessionexpired");
                                this.$router.push({ path: "/login", query: { logoutreason: "sessionExpired" } }).catch(function () { return undefined; });
                            }
                            // eslint-disable-next-line
                            console.error("Socket: Token-Refresh fehlgeschlagen", error_1);
                            return [2 /*return*/, null];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * DISPO-1216: naechsten Verbindungsversuch einplanen (einer zur Zeit).
         */
        scheduleReconnect: function () {
            if (this.reconnectTimeoutId) {
                window.clearTimeout(this.reconnectTimeoutId);
            }
            this.reconnectTimeoutId = window.setTimeout(this.connect, 5000);
        },
        /**
         * DISPO-1216: Fehler-Toast einmal je Stoerung, und erst wenn die Verbindung nach
         * SOCKET_ERROR_TOAST_GRACE_MS immer noch nicht wieder steht. Gezeigt wird der
         * Text des letzten Fehlschlags.
         */
        showSocketErrorToast: function (text, autoHideDelay) {
            var _this = this;
            if (this.socketErrorToastShown) {
                return;
            }
            this.pendingSocketErrorText = text;
            this.pendingSocketErrorHideDelay = autoHideDelay;
            if (this.socketErrorToastTimeoutId) {
                return;
            }
            this.socketErrorToastTimeoutId = window.setTimeout(function () {
                _this.socketErrorToastTimeoutId = null;
                if (_this.connected || !_this.currentUser) {
                    return;
                }
                _this.socketErrorToastShown = true;
                _this.$bvToast.toast(_this.pendingSocketErrorText, {
                    title: "Socket-Verbindung zu Server fehlgeschlagen",
                    autoHideDelay: _this.pendingSocketErrorHideDelay,
                    variant: "danger",
                    solid: true,
                });
            }, SOCKET_ERROR_TOAST_GRACE_MS);
        },
        /**
         * DISPO-1216: Verbindung steht wieder bzw. Logout -> verzoegerten Toast verwerfen.
         */
        clearSocketErrorToast: function () {
            if (this.socketErrorToastTimeoutId) {
                window.clearTimeout(this.socketErrorToastTimeoutId);
                this.socketErrorToastTimeoutId = null;
            }
            this.socketErrorToastShown = false;
        },
        /**
         * connect to websocket server and subscribe to the different topics and start sending heartbeat messages
         */
        connect: function () {
            return __awaiter(this, void 0, Promise, function () {
                var accessToken, connectHeaders;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // DISPO-1197: ohne angemeldeten User keine Verbindung (z.B. verspaeteter
                            // Reconnect-Timer nach dem Logout); eine bestehende Verbindung nicht doppeln.
                            if (!this.currentUser || this.connecting) {
                                return [2 /*return*/];
                            }
                            if (this.$configuration.stompClient &&
                                this.$configuration.stompClient.connected) {
                                return [2 /*return*/];
                            }
                            this.reconnectTimeoutId = null;
                            this.connecting = true;
                            accessToken = null;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, this.ensureFreshSocketToken()];
                        case 2:
                            accessToken = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            this.connecting = false;
                            return [7 /*endfinally*/];
                        case 4:
                            // waehrend des Refresh abgemeldet (disconnect) -> nicht mehr verbinden
                            if (!this.currentUser) {
                                return [2 /*return*/];
                            }
                            if (!accessToken) {
                                this.showSocketErrorToast("Anmeldung fuer die Live-Verbindung nicht moeglich, neuer Versuch in 5 s", 5000);
                                this.scheduleReconnect();
                                return [2 /*return*/];
                            }
                            this.socket = new SockJS(this.$configuration.BASE_URL_WEBSOCKET + "gs-guide-websocket");
                            this.$configuration.stompClient = Stomp.over(this.socket, { debug: false });
                            //only generate this id once per app instance
                            if (this.$configuration.socketHeartBeatStatus.tabId == null) {
                                this.$configuration.socketHeartBeatStatus.tabId = this.generateTabId();
                            }
                            if (this.$configuration.socketHeartBeatStatus.username == null) {
                                this.$configuration.socketHeartBeatStatus.username = this.currentUser.username;
                            }
                            connectHeaders = { Authorization: "Bearer " + accessToken };
                            this.$configuration.stompClient.connect(connectHeaders, 
                            // eslint-disable-next-line
                            function (frame) {
                                _this.connected = true;
                                _this.clearSocketErrorToast(); // DISPO-1216: naechste Stoerung darf wieder melden
                                //handle entity updates (CRUD) from other users
                                _this.$configuration.stompClient.subscribe("/topic/updates", function (message) {
                                    _this.handleUpdatesTopicMessage(message);
                                });
                                //handle edit status information (blur and focus events on intput field from other users)
                                _this.$configuration.stompClient.subscribe("/topic/editstatus", function (message) {
                                    _this.handleEditStatusUpdate(message);
                                });
                                //handle all global user status updates (coming in in every 5 seconds)
                                _this.$configuration.stompClient.subscribe("/topic/userstatus", function (message) {
                                    _this.handleUsersStatusUpdate(message);
                                });
                                _this.startHeartBeat();
                                _this.sendConnectionHello();
                            }, function (error) {
                                if (error.type && error.type === "close") {
                                    _this.showSocketErrorToast(error.reason || "Verbindung getrennt, neuer Versuch in 5 s", 2000);
                                    _this.scheduleReconnect();
                                }
                                else {
                                    // DISPO-1216: STOMP-ERROR-Frame. Hat der Server den Token abgelehnt
                                    // (abgelaufen/ungueltig), vor dem naechsten Versuch einen neuen holen.
                                    // Der Server schliesst danach die Verbindung -> Reconnect ueber den close-Zweig.
                                    var message = (error.headers && error.headers.message) || "";
                                    if (/token/i.test(message)) {
                                        _this.forceTokenRefresh = true;
                                    }
                                    _this.showSocketErrorToast(message || JSON.stringify(error), 5000);
                                    // eslint-disable-next-line
                                    console.error("Stomp error", error);
                                }
                                _this.connected = false;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        },
        /**
         * disconnect from websocket server and stop sending heartbeat messages
         */
        disconnect: function () {
            // DISPO-1197: auch einen anstehenden Reconnect abbrechen und den
            // Heartbeat-Status zuruecksetzen, damit ein Re-Login im selben Tab
            // nicht mit dem alten Usernamen weitersendet.
            if (this.reconnectTimeoutId) {
                window.clearTimeout(this.reconnectTimeoutId);
                this.reconnectTimeoutId = null;
            }
            this.stopHeartBeat();
            if (this.$configuration.stompClient) {
                try {
                    this.$configuration.stompClient.disconnect();
                }
                catch (error) {
                    // eslint-disable-next-line
                    console.error(error);
                }
                this.$configuration.stompClient = null;
            }
            this.$configuration.socketHeartBeatStatus.username = null;
            this.$configuration.socketHeartBeatStatus.entityId = null;
            this.$configuration.socketHeartBeatStatus.focussedFieldId = null;
            this.$configuration.socketHeartBeatStatus.editModeActive = false;
            this.connected = false;
            this.forceTokenRefresh = false;
            this.clearSocketErrorToast();
        },
        /*************************** HELPER FUNCTIONS  ******************************/
        /**
         * generate a "unique" ID for this instance of the APP which is used to identify a browser tab against the backend (if user opens more than one tab)
         */
        generateTabId: function () {
            var dt = new Date().getTime();
            var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                var r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
            });
            return uuid;
        },
    },
    computed: {
        currentUser: function () {
            return this.$store.state.auth.user;
        },
    },
});
